import React from 'react';

import type { RouteMatch } from '@confluence/route';
import {
	CONTAINER_HOME_ID,
	COMPANY_HUB_SETTINGS_ID,
} from '@confluence/app-navigation/entry-points/navigationIDs';
import { isCompanyHubSpaceKey } from '@confluence/route-manager/entry-points/companyHubUtils';
import { ContentHistoryLoader } from '@confluence/content-history';

export const ContentHistoryRoute = ({ params: { spaceKey, contentId } }: RouteMatch) => (
	<ContentHistoryLoader spaceKey={spaceKey} contentId={contentId} stack="classic" />
);

ContentHistoryRoute.NAVIGATION_PARAMS = ({
	params: { spaceKey, contentId, contentSlug },
}: RouteMatch) => ({
	Screen: {
		screenEvent: { name: 'pageHistoryScreen', id: contentId },
		pageState: {
			spaceKey,
			contentId,
			contentSlug,
		},
	},
	MainLayout: {
		spaceKey,
		navView: isCompanyHubSpaceKey(spaceKey) ? COMPANY_HUB_SETTINGS_ID : CONTAINER_HOME_ID,
	},
});
